import TemplateView from '../TemplateView'

export default class DraggablePopup extends TemplateView {
    constructor({
        contentComponent = null,
        additionalClass = '',
        showHideButton = true,
        noDragClass = '',
        onShow = () => {},
        onHide = () => {},
        onDragStop = () => {},
    } = {}) {
        super(null)

        this.params = {
            contentComponent,
            additionalClass,
            showHideButton,
            noDragClass,
        }

        this.callbacks = {
            onShow,
            onHide,
            onDragStop,
        }
    }

    templateHtml() {
        return '<div class="components_draggablePopup <%-additionalClass%> ">' +
               '    <div class="dragIcon"/>' +
               '    <div class="hideButton"/>' +
               '    <div class="content"/>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$hideButton = this.find('.hideButton')
        this.params.contentComponent.init(this.find('.content'))

        if (!this.params.showHideButton) {
            this.$hideButton.hide()
        } else {
            this.$hideButton.click(() => this.hide())
        }

        this.getEl().draggable({
            cancel: this.params.noDragClass ? `.${this.params.noDragClass}` : '',
            containment: 'document',
            stop: () => this.callbacks.onDragStop(),
        })
    }

    hide() {
        this.callbacks.onHide()
        super.hide()
    }

    show() {
        this.callbacks.onShow()
        super.show()
    }
}



// WEBPACK FOOTER //
// ./web/js/components/DraggablePopup.js